import type { ComponentProps } from 'react'

import { cn } from './cn'

/**
 * A raised surface: the `surface` fill, a `line` outline and 14px corners. On hover
 * the border turns primary and the shadow lifts, so a card visibly responds.
 */
export function Card({ className, children, ...props }: ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'rounded-xl border border-line bg-surface shadow-card transition duration-200 hover:border-primary-main hover:shadow-card-hover',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
